import { Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { COLORS } from "../../theme";

const defaultProps = {
  fontWeight: 600,
  color: '#222222', // Svart enligt styleguide
  fontFamily: 'Poppins, sans-serif',
  fontSize: '16px',
  sx: {}
};

export const H4 = ({ children, fontWeight, color, fontFamily, fontSize, sx }) => {
  return (
    <Typography 
      variant="h4" 
      sx={{ 
        fontWeight: fontWeight || 600, 
        color: color || '#222222', 
        fontFamily: fontFamily || 'Poppins, sans-serif', 
        fontSize: fontSize || { xs: '15px', md: '16px' },
        marginBottom: '0.5rem', // 8px default spacing
        ...(sx || {}) 
      }}
    >
      {children}
    </Typography>
  );
};

H4.propTypes = {
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  sx: PropTypes.object
};

H4.defaultProps = defaultProps;

export default H4;
